import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    color: theme.palette.textcolor.main,
    textTransform: 'uppercase',
    fontSize: '1.4375em',
    fontStyle: 'italic',
    marginBottom: 10,
  },
  text: {
    color: '#000000',
    maxWidth: 810,
  },
  filter: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 10,
    marginTop: 10,
    '@media (max-width: 750px)': {
      display: 'block',
    },
  },
  filterBy: {
    display: 'flex',
    alignItems: 'center',
    '& p': {
      fontStyle: 'italic',
      fontWeight: '600',
      fontSize: '1.1em',
      fontFamily: 'Source Sans Pro, sans-serif',
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.1em',
      },
    },
  },
  toggles: {
    marginLeft: 20,
  },
  toggleItem: {
    border: 'none',
    backgroundColor: 'transparent',
    padding: 0,
    marginRight: 20,
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        display: 'block',
        bottom: -2,
        left: 0,
        width: '100%',
        height: 3,
        backgroundColor: theme.palette.primary.main,
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '& p': {
        color: theme.palette.secondary.main,
      },
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& p': {
      fontStyle: 'normal',
      color: '#36659C59',
    },
  },
  toggleText: {
    color: '#5C5C5C',
  },
  search: {
    position: 'relative',
    borderRadius: 5,
    border: '1px solid #C1C1BF',
    marginLeft: 0,
    width: '100%',
  },
  searchIcon: {
    padding: '0 5px',
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#707070',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(3)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '20ch',
      '&:focus': {
        width: '25ch',
      },
    },
    '&::placeholder': {
      fontSize: '14px',
    },
  },
  tableInfo: {
    position: 'relative',
    fontFamily: 'Source Sans Pro, sans-serif',
    '& .disabled': {
      filter: 'blur(5px)',
      userSelect: 'none',
    },
    '& .MuiTableCell-root': {
      fontSize: 12,
    },
  },
  tableInfoWarning: {
    position: 'absolute',
    fontSize: '0.9em',
    top: '50%',
    left: '50%',
    marginTop: -10,
    marginLeft: -148.5,
    zIndex: 10,
  },
  tableCellHeading: {
    fontWeight: 600,
    color: '#5C5C5C',
    lineHeight: 1,
  },
  tableInfoTitle: {
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'left',
    borderBottom: 'none',
    backgroundColor: '#FAF9F6',
    fontFamily: 'Source Sans Pro, sans-serif',
  },
}));

export default useStyles;
